import React from 'react';

const CustomAnswerNextMapField = (props) => {
  const { formData = {}, onChange, schema } = props;

  const handleKeyChange = (oldKey, newKey) => {
    if (!newKey || newKey === oldKey) return;
    const newFormData = { ...formData };
    newFormData[newKey] = newFormData[oldKey];
    delete newFormData[oldKey];
    onChange(newFormData);
  };

  const handleValueChange = (key, value) => {
    onChange({ ...formData, [key]: value });
  };

  const handleAdd = () => {
    let newKey = 'user response';
    let i = 1;
    while (formData.hasOwnProperty(newKey)) {
      newKey = `user response ${i}`;
      i++;
    }
    onChange({ ...formData, [newKey]: '' });
  };

  const handleRemove = (key) => {
    const newFormData = { ...formData };
    delete newFormData[key];
    onChange(newFormData);
  };

  return (
    <div>
      <div style={{ marginBottom: 8, fontWeight: 'bold' }}>Answer to Next Question Mapping</div>
      {Object.entries(formData).map(([key, value], idx) => (
        <div key={idx} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
          <input
            value={key}
            onChange={e => handleKeyChange(key, e.target.value)}
            placeholder="Answer"
            style={{ flex: 1 }}
          />
          <select
            value={value}
            onChange={e => handleValueChange(key, e.target.value)}
            style={{ flex: 2 }}
          >
            <option value="">Select next step</option>
            {schema.additionalProperties.enum?.map(opt => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
          <button type="button" onClick={() => handleRemove(key)} style={{ color: 'red', border: 'none', background: 'none', fontSize: 18, cursor: 'pointer' }}>✕</button>
        </div>
      ))}
      <button type="button" onClick={handleAdd} style={{ marginTop: 8 }}>Add Mapping</button>
    </div>
  );
};

export default CustomAnswerNextMapField;